import React from 'react'
import "./Roadmap.css"

const Roadmap = () => {
    


    return (
        <div className='flex flex-col flex-wrap relative w-full h-[85vh]    justify-center items-center ' id="roadmap">
            <div className='container mx-auto flex flex-col flex-wrap justify-around items-center text-white relative'>

                <div className='flex flex-wrap flex-col text-white mt-10 justify-center items-center mb-20 '>
                    <h2 className='font-medium text-5xl'>Scrib Roadmap</h2>
                </div>
                <div className='book '>
                    <input type="checkbox" id="c1"/>
                    <input type="checkbox" id="c2"/>
                    <input type="checkbox" id="c3"/>
                    <input type="checkbox" id="c4"/>
                    <div className='flip-book'>
                    <div className='flip' id="p1">
                            <div className='back'>
                                <h2></h2>
                                <label className=' back-btn border-[1px] px-2 rounded-xl font-bold' for="c1">back</label>
                            </div>
                            <div className='front justify-center text-white items-center flex flex-col'>
                                <h2 className=' text-2xl text-white uppercase font-turrent'>The Roadmap</h2>
                                <p className=''>NFT Guid Book</p>
                                <label className='next-btn border-[1px] px-2 rounded-xl font-bold' for="c1">next</label>
                            </div>
                        </div>
                        <div className='flip' id="p2">
                            <div className='back'>
                                <h2></h2>
                                <label className=' back-btn  border-[1px] px-2 rounded-xl font-bold' for="c2">back</label>
                            </div>
                            <div className='front justify-center  text-white items-center flex flex-col'>
                                <h2 className=' text-2xl  '>Phase-01</h2>
                                <p className='mt-4'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cum minus sint sed. Necessitatibus totam vel tenetur inventore doloremque. Vel, animi! Dignissimos doloribus blanditiis veritatis corrupti officia eaque eligendi inventore.</p>
                                <label className='next-btn border-[1px] px-2 rounded-xl font-bold' for="c2">next</label>
                            </div>
                        </div>
                        <div className='flip' id="p3">
                            <div className='back'>
                                <h2></h2>
                                <label className=' back-btn border-[1px] px-2 rounded-xl font-bold' for="c3">back</label>
                            </div>
                            <div className='front justify-center text-white items-center flex flex-col'>
                                <h2 className=' text-2xl text-whit '>Phase-01</h2>
                                <p className='mt-4'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cum minus sint sed. Necessitatibus totam vel tenetur inventore doloremque. Vel, animi! Dignissimos doloribus blanditiis veritatis corrupti officia eaque eligendi inventore.</p>
                                <label className='next-btn border-[1px] px-2 rounded-xl font-bold' for="c3">next</label>
                            </div>
                        </div>
                        <div className='flip' id="p4">
                            <div className='back'>
                                <h2></h2>
                                <label className=' back-btn border-[1px] px-2 rounded-xl font-bold' for="c4">back</label>
                            </div>
                            <div className='front justify-center items-center text-white flex flex-col'>
                                <h2 className=' text-2xl text-whit '>Phase-01</h2>
                                <p className='mt-4'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil cum minus sint sed. Necessitatibus totam vel tenetur inventore doloremque. Vel, animi! Dignissimos doloribus blanditiis veritatis corrupti officia eaque eligendi inventore.</p>
                                <label className='next-btn border-[1px] px-2 rounded-xl font-bold' for="c4">next</label>
                            </div>
                        </div>
                    </div>
             
                
                   
                </div>
            </div>
        </div>
    )
}

export default Roadmap